import axios from "axios"
import { url } from "../helper"
// import { useDatabase } from "./useDatabase"
import { ref, Ref } from "vue"

interface UseSession {
	getSession: () => void
	sessionToken: Ref<string | undefined>
	csrfToken: Ref<string | undefined>
	logoutToken: Ref<string | undefined>
	setLogoutToken: () => void
	setCsrfToken: () => void
	setLoginToken: (token: string) => void
	loginToken: Ref<string | undefined>
}

const sessionToken = ref<string | undefined>(undefined)
const logoutToken = ref<string | undefined>(undefined)
const csrfToken = ref<string | undefined>(undefined)
const loginToken = ref<string | undefined>(undefined)

/**
 * Fetches a session token from the server.
 * @returns {Object} An object containing the session token.
 */
export const useSession = (): UseSession => {
	// const { get } = useDatabase()
	const getSession = async () => {
		if (sessionToken.value) return
		await axios.get(`${url}/session/token`).then((response) => {
			sessionToken.value = response.data
		})
	}
	// const setCsrfToken = async () => {
	// 	const token = await get("csrf", 0)
	// 	csrfToken.value = token.csrf_token
	// }
	// const setLogoutToken = async () => {
	// 	const token = await get("user", 1)
	// 	logoutToken.value = token.logoutToken
	// }
	const setLoginToken = (token: string) => {
		loginToken.value = token
	}

	return {
		getSession,
		sessionToken,
		logoutToken,
		csrfToken,
		setLoginToken,
		loginToken,
	}
}
